import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import { MainLayoutTopComponent } from "./MainLayoutTopComponent";

export function MainLayout({ showModeView }) {
  return (
    <Box
      sx={{
        bgcolor: "primary.dark",
        padding: "2rem 2.5rem 1.25rem",
        overflowX: "clip",
      }}
      component={"main"}
    >
      <MainLayoutTopComponent open={false} showModeView={showModeView} />
      <Outlet />
    </Box>
  );
}
